
import { Tbl_mvpEdit } from './tbl_mvpEdit';
import { Tbl_mvpList } from './tbl_mvpList';
import { Tbl_mvpShow } from './tbl_mvpShow';
import { Tbl_mvpCreate } from './tbl_mvpCreate';
import MapIcon from '@material-ui/icons/Map';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_mvpList,
    edit: Tbl_mvpEdit,
    show: Tbl_mvpShow,
    create: Tbl_mvpCreate,
    icon: MapIcon
};
            